import ics.react.createReactApp
import react.create

fun main() {
    createReactApp(Application.create())
}